import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { BiTableDensity, kBiVizStyleDefaults } from '@euler/model/bi/viz';
import { memo } from 'react';
import { View } from 'react-native';
import { MarkdownTable } from '../../markdown/MarkdownTable';
import { CopyTableButton } from './CopyTableButton';
import { BiTableModel } from './functions/biResultTable';
import { BiVizLook } from './functions/biVizLook';

/** Rows a card shows; the snapshot may hold up to 1,000. */
const kShownRows = 50;

/**
 * A result table, its first rows and how many there are, styled by
 * `style.table`: density, zebra rows, a totals row over every row; its
 * values copy as stored, from a button under it unless its container
 * offers the copy itself (a dashboard card floats it).
 */
export const BiResultTable = memo(
  ({
    table,
    look = kBiVizStyleDefaults.table,
    inlineCopy = true,
  }: {
    table: BiTableModel;
    look?: BiVizLook['table'];
    inlineCopy?: boolean;
  }) => (
    <View style={{ gap: 6 }}>
      <MarkdownTable
        rows={[table.header, ...table.body.slice(0, kShownRows)]}
        align={table.align}
        zebra={look.zebra}
        compact={look.density === BiTableDensity.Compact}
        footer={look.totalsRow ? table.totals : undefined}
      />
      {table.body.length > kShownRows ? (
        <CardNotice
          text={`共 ${table.body.length} 行，这里显示前 ${kShownRows} 行${
            look.totalsRow ? '，合计包含全部行' : ''
          }。`}
        />
      ) : null}
      {inlineCopy ? (
        <View style={{ alignItems: 'flex-end' }}>
          <CopyTableButton table={table} />
        </View>
      ) : null}
    </View>
  ),
);
